<template lang="pug">
HeadlessPopover
  PopoverButton.btn.p-0.aspect-square.w-10.h-10.relative.text-xl.p-0.ripple.ripple--centered(
    class="!border-none !outline-none"
    id="author-main-menu-toggle"
  )
    Icon(icon="ph:list")
    .badge.h-4.w-4.bg-red-600.absolute.-top-1.-right-1.rounded-full.flex.items-center.justify-center(
      v-if="expired"
    ) 
      span.text-xs.text-white !

  transition(
    enter-active-class="transition duration-100 ease-out"
    enter-from-class="transform scale-95 opacity-0"
    enter-to-class="transform scale-100 opacity-100"
    leave-active-class="transition duration-75 ease-in"
    leave-from-class="transform scale-100 opacity-100"
    leave-to-class="transform scale-95 opacity-0"
  )
    PopoverPanel.absolute.left-0.mt-2.w-auto.origin-top-left.divide-y.divide-stone-100.rounded-md.bg-white.shadow-lg.ring-1.ring-black.ring-opacity-5(
      class="focus:outline-none"
    )
      .px-1.py-1
        .flex.py-4.pe-4.gap-4.border-0.border-b1.border-stone-300
          .inline-flex.flex-none.items-center.justify-center.h-16.w-16.aspect-sqaure.bg-red-800.text-white.rounded-full
            .text-xl {{ initials }}
          .flex-1
            p.font-bold.text-red-700(v-if="expired") Session expired
            p.font-bold Hello, {{ firstName }}
            p.text-stone-600.text-sm {{ email }}
            p.text-sm
              button.text-sky-600.hover_text-sky-400.border-0(
                @click="logout"
                type="button"
              ) 
                Icon.inline.me-2(icon="carbon:logout")
                span Sign out

        slot
</template>

<script lang="ts">
export default {
  name: 'MainMenu'
};
</script>

<script setup lang="ts">
import {
  Popover as HeadlessPopover,
  PopoverButton,
  PopoverPanel
} from '@headlessui/vue';
import { Icon } from '@iconify/vue';
import { computed } from 'vue';
import getTenant from '../../lib/getTenant';
import useJWT from '../lib/useJWT';
import { redirect } from '../lib/authRedirect';
import { domain } from '../../lib/getJWT';

const { jwt } = useJWT();

const profile = computed(() => {
  if (!jwt.value) return null;
  return jwt.value.userProfile;
});

const expired = computed(() => {
  if (!jwt.value) return false;
  return jwt.value.exp * 1000 < Date.now();
});

const firstName = computed(() => profile.value?.firstName);
const lastName = computed(() => profile.value?.lastName);
const email = computed(() => profile.value?.email);

const initials = computed(() => {
  if (!firstName.value || !lastName.value) return '';
  return `${firstName.value.charAt(0)}${lastName.value.charAt(0)}`;
});

const logout = () => {
  document.cookie = `auth-header-${getTenant()}=; Max-Age=-99999999; path=/; domain=${domain};`;
  redirect();
};
</script>
